import { render, staticRenderFns } from "./CreationForm.vue?vue&type=template&id=6db176e8&scoped=true"
import script from "./CreationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreationForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CreationForm.vue?vue&type=style&index=0&id=6db176e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db176e8",
  null
  
)

export default component.exports